import { ChevronDownIcon } from 'lucide-react';

import { Button } from '@/components/core/button';

type ShowMoreOrderLinesButtonProps = {
  hiddenLineCount: number;
  onClick: () => void;
};

export function ShowMoreOrderLinesButton({
  hiddenLineCount,
  onClick,
}: ShowMoreOrderLinesButtonProps) {
  return (
    <div className="flex h-10 items-stretch border-t">
      <Button
        type="button"
        variant="outline"
        className="h-full w-full justify-start rounded-none border-0 px-4 font-normal text-muted-foreground shadow-none"
        onClick={onClick}
      >
        <ChevronDownIcon />
        Show {hiddenLineCount} more {hiddenLineCount === 1 ? 'item' : 'items'}
      </Button>
    </div>
  );
}
